<template>
    <AppSection
        v-if="hasSponsors"
        :backgroundColor="backgroundColor"
        :backgroundImage="backgroundImage"
        :topPadding="topPadding"
        :bottomPadding="bottomPadding"
        :fillHeight="fillHeight"
    >
        <div class="scc-container">
            <div class="sponsor-gallery">
                <h2 class="sponsor-gallery__title">{{ title }}</h2>
                <div class="sponsor-gallery__inner">
                    <template v-for="(sponsor, index) in sponsorList">
                        <article v-if="sponsor.logo" :key="index" class="sponsor-gallery__item">
                            <img
                                :src="sponsor.logo | cdn({ width: 240 })"
                                class="sponsor-gallery__image"
                                alt="Sponsor logo"
                            />
                        </article>
                    </template>
                </div>
            </div>
        </div>
    </AppSection>
</template>

<script>
import './sponsor-gallery.scss';
import AppSection from '../global/AppSection';

export default {
    name: 'SponsorGallery',
    components: { AppSection },
    __editor: {
        requiredData: ['sponsors'],
        fields: {
            title: {
                widget: 'text',
                default: 'Onze sponsoren',
            },
            backgroundImage: {
                type: String,
            },
            backgroundColor: {
                type: String,
                required: false,
                default: 'white',
            },
            topPadding: {
                type: String,
                required: false,
                default: 'medium',
            },
            bottomPadding: {
                type: String,
                required: false,
                default: 'medium',
            },
            fillHeight: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
    },
    props: {
        title: {
            type: String,
            default: 'Onze sponsoren',
        },
        backgroundImage: {
            type: String,
        },
        backgroundColor: {
            type: String,
            required: false,
            default: 'white',
        },
        topPadding: {
            type: String,
            required: false,
            default: 'medium',
        },
        bottomPadding: {
            type: String,
            required: false,
            default: 'medium',
        },
        fillHeight: {
            type: Boolean,
            required: false,
            default: false,
        },
        sponsors: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
    computed: {
        sponsorList() {
            return this.sponsors;
        },
        hasSponsors() {
            return this.sponsorList && this.sponsorList.length > 0;
        },
    },
};
</script>
